import React, { Component } from "react";
import { Container, Col, Row, Button, Table } from "react-bootstrap";
import cinstance from "../../Service/randomcinstance";
import usercinstance from "../../Service/usercinstance";
import web3 from "../../Service/web3";
import AdminNavBar from "../../Components/AdminNavBar";

class OrganisationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seed: "",
      loading: false,
      Randomresult: "",
      winner: "",
      orglist: [],
      show: false,
    };
  }

  async componentDidMount() {
    var orglist = [];
    if (window.ethereum) {
      window.web3 = web3;
      cinstance.methods
        .admin()
        .call()
        .then(async (p) => {
          let account = await web3.eth.getAccounts();
          if (p == account[0]) this.setState({ show: true });
          usercinstance.methods
            .ownerId()
            .call()
            .then((res) => {
              for (var i = res - 1; i > 0; i--) {
                usercinstance.methods
                  .organisationbyid(i)
                  .call()
                  .then((responseAddress) => {
                    usercinstance.methods
                      .organisationbyaddr(responseAddress)
                      .call()
                      .then((response) => {
                        orglist.push(response);
                        this.setState({ orglist });
                      });
                  })
                  .catch((err) => console.log("pepep", err));
              }
            })
            .catch((err) => console.log("res", err));
        });
    }
  }

  approve = async (id) => {
    if (window.ethereum) {
      window.web3 = web3;
      let account = await web3.eth.getAccounts();
      cinstance.methods
        .admin()
        .call()
        .then((res) => {
          if (res == account[0]) {
            cinstance.methods
              .approveOraganisation(id)
              .send({ from: account[0] })
              .then((res) => {
                window.location.reload();
              });
          } else alert("Not admin");
        });
    }
  };

  render() {
    const { orglist, show } = this.state;
    return (
      <>
        <AdminNavBar />
        {!show && (
          <Container className="bgImage  p-o">
            <div className="mspace mt-5">
              <h2>Not an admin</h2>
            </div>
          </Container>
        )}
        {show && (
          <Container className="bgImage  p-o m-0" fluid>
            <div className="mspace1">
              <h3
                className="text-center section-title mt-2"
                style={{ fontWeight: "600", fontSize: "28px", color: "#444" }}
              >
                {" "}
                Creators List
              </h3>

              <div className="content bookieslist adspace">
                <Row>
                  {orglist.map((item) => (
                    <Col lg="4" md="6">
                      <div className="overview-item text-left">
                        <p>
                          <b>ID : </b> &nbsp;&nbsp;{item.id}
                          <br></br>
                          <b>Name : </b> &nbsp;&nbsp;
                          {item.name}
                          <br></br>
                          <b>Max Prize : </b> &nbsp;&nbsp;
                          {web3.utils.fromWei(`${item.maxPrize}`, "ether")} POL
                          <br></br>
                          <b>Min Prize : </b> &nbsp;&nbsp;
                          {web3.utils.fromWei(`${item.minPrize}`, "ether")} POL
                          <br></br>
                          <p style={{ wordBreak: "break-all" }}>
                            <b>Address : </b> &nbsp;&nbsp;
                            {item.userAddress}
                          </p>
                          <b>Action : </b> &nbsp;&nbsp;
                          {item.active ? (
                            "Approved"
                          ) : (
                            <Button onClick={() => this.approve(item.id)}>
                              Approve
                            </Button>
                          )}
                          <br></br>
                        </p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Container>
        )}
      </>
    );
  }
}

export default OrganisationList;
